<template>
  <div class="proposal-modal" v-if="isVisible">
    <div class="header">
        <div class="left flex">
            <span>Status</span>
            <div class="status" :class="{ completed: currentProposal.status === 'Accepted', pending: currentProposal.status === 'Pending', declined: currentProposal.status === 'Declined' }">
                <span>{{ currentProposal.status }}</span>
            </div>
        </div>

        <div class="right">
            <button class="btn dbtn" @click="deleteProposal(currentProposal.docId)"><i class="fa-solid fa-trash" /> Delete</button>
        </div>
    </div>

    <div class="modal-content">
        <div class="top flex">
            <div class="left flex">
                <p><span>#</span>{{ currentProposal.proposalId }}</p>
            </div>

            <div class="right flex-column">
                <h4>Mail Date:</h4>
                {{ currentProposal.submissionDate }}
            </div>
        </div>

        <div class="middle flex-column">
            <h3>Details:</h3>
            <div class="details">
                <div class="flex-column">
                    <h4>Client Name:</h4>
                    <p>{{ currentProposal.clientName }}</p>
                </div>
                <div class="flex-column">
                    <h4>Client Email:</h4>
                    <p>{{ currentProposal.clientEmail }}</p>
                </div>
                <div class="flex-column">
                    <h4>Client Phone No:</h4>
                    <p>{{ currentProposal.clientPhoneNumber }}</p>
                </div>
            </div>
        </div>

        <div class="bottom flex-column">
            <div class="flex-column">
                <h4>Subject:</h4>
                <p>{{ currentProposal.emailSubject }}</p>
            </div>

            <div class="report flex-column">
                <h4>Client Request:</h4>
                <p>{{ currentProposal.clientRequest }}</p>
            </div>
        </div>

        <div class="buttons flex">
            <div class="close">
                <button @click="closeModal" class="dbtn"><i class="fa-regular fa-circle-xmark" />Close</button>
            </div>
            <div class="accept">
                <button class="cbtn" @click="acceptProposal(currentProposal.docId)">Accept</button>
                <button class="dbtn" @click="declineProposal(currentProposal.docId)">Decline</button>
            </div>
        </div>

    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
export default {
    name: 'Proposals',
    props: {
        isVisible: Boolean,
        currentProposal: Object,
    },

    methods: {
        ...mapActions(['DELETE_PROPOSAL', 'ACCEPT_PROPOSAL', 'DECLINE_PROPOSAL' ]),

        closeModal() {
            this.$emit('close');
        },

        async deleteProposal(docId) {
            await this.DELETE_PROPOSAL(docId);
            this.$emit('close');
            this.$toast.open({
                message: 'Proposal was successfully deleted.',
                type: 'success',
                position: 'top',
                duration: 3000,
            })
        },

        async acceptProposal(docId){
            await this.ACCEPT_PROPOSAL(docId);
            this.$emit('close');
            this.$toast.open({
                message: 'Proposal status was successfully updated.',
                type: 'success',
                position: 'top',
                duration: 3000,
            });
        },

        async declineProposal(docId){
            await this.DECLINE_PROPOSAL(docId);
            this.$emit('close');
            this.$toast.open({
                message: 'Proposal status was successfully updated.',
                type: 'success',
                position: 'top',
                duration: 3000,
            });
        }
    },
};
</script>

<style lang="scss" scoped>



.proposal-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    min-height: 100vh;
    background: rgba(255, 255, 255, 0.096);
    backdrop-filter: blur(8px);
    z-index: 200000;
    overflow: auto;


    p {
        color: white;
        
        @media(max-width: 500px) {
            font-size: 80%;
        }
    }



    .header, .modal-content {
        border-radius: 20px;
        background: rgba(128, 128, 128, 0.5);
        width: 100%;
        padding: 40px 10px;
        max-width: 700px;
        margin: 1.5rem auto;
        
    }


    .header {
        display: flex;
        align-items: center;
        padding: 24px 32px;
        justify-content: space-between;
        margin-top: 5rem;

        .left {
            align-items: center;

            span {
                color: black;
                font-size: 12px;
                padding-right: 10px;
            }

        }

        .right {

            .btn {
                cursor: pointer;
                padding: 12px 18px;
                border-radius: 10px;
                border: none;
                font-size: 12px;
                margin-right: 8px;
            }
        }
    }


    .modal-content {
        padding: 48px;

        .top {
            div {
                flex: 1;
            }

            .left {
                font-size: 12px;
                
                p:first-child {
                    font-size: 18px;
                    text-transform: uppercase;
                    color: white;
                    margin-bottom: 8px;
                }
            }

            .right {
                font-size: 13px;
                align-items: flex-end;
            }
        }

        .middle {
            margin-top: 30px;
            gap: 16px;

            .details {
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                grid-gap: 2rem;
                flex: 1;
                width: 100%;


                div {
                    // padding-top: .7rem ;

                    h4 {
                        font-size: 12px;
                    }

                    p {
                        font-size: 90%;
                    }
                }
            }
        }

        .bottom {
            margin-top: 2rem;

            div {
                padding: .3rem 0;

                h4 {
                    font-size: 12px;
                }

                p {
                    font-size: 90%;
                }

            }

        }

        .buttons {
            margin-top: 2.5rem;
            justify-content: space-between;
            width: 100%;

            div {
                button {
                    display: block;
                    padding: .6rem .9rem;
                    border-radius: 20px;
                    border: none;

                    i {
                        padding-right: .4rem;
                    }

                    &:hover {
                        cursor: pointer;
                    }
                }

            }

            .close {
                button {
                    display: inline-block;
                }
            }

            .accept {
                button {
                    display: inline-flex;

                    &:first-child {
                        margin-right: .7rem;
                    }
                }
            }
        }
    }
}
</style>